import React from 'react';
import findResult, { hasKey } from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import urls, { cohortUrl, relativeUrl, startsWithUrl } from '@/constants/urls';
import PanelContainer from '@/components/wrappers/PanelContainer';
import { updateCohortProperties } from '../actions';
import { canEditCohort } from '../helper';

const CohortPanelContainer = ({
  canRead,
  children,
  description,
  exists,
  isDirty,
  isNew,
  name,
  onChange,
  readErrors,
  readStatus,
  saveErrors,
  url,
  validationErrors,
}) => (
  <PanelContainer
    canAccess={canRead}
    description={description}
    entity="cohort"
    exists={exists}
    isDirty={!isNew && isDirty}
    isNew={isNew}
    name={name}
    onChange={onChange}
    readErrors={readErrors}
    readStatus={[readStatus]}
    saveErrors={saveErrors}
    validationErrors={validationErrors}
    url={url}
  >
    {children}
  </PanelContainer>
);

const accessControl = (role, exists, isNew) => (
  {
    exists,
    isNew,
    canRead: exists ? role.permissions.cohorts.read : false,
  }
);

const withoutItem = (role, url) => (
  {
    ...accessControl(role, false, !startsWithUrl(url, relativeUrl(urls.COHORTS))),
    ...readStates,
    queryAccess: false,
    allowCohortVisualisations: false,
    expandedCharts: false,
    datasetCohortVisibilities: [],
    canEdit: false,
  }
);

const withItem = (item, role, url) => {
  const isNewExists = hasKey(item, 'isNew');
  const genuineCohortUrl = startsWithUrl(url, relativeUrl(urls.COHORTS));
  const urlForCohort = isNewExists && !item.isNew ? cohortUrl(item) : url;
  const isNew = isNewExists ? item.isNew : !genuineCohortUrl;
  const { settings } = item;

  return (
    {
      ...accessControl(role, true, isNew),
      canEdit: canEditCohort({ permissions: item.permissions, isNew }, role),
      code: item.code,
      url: urlForCohort,
      isDirty: item.isDirty,
      isEditing: item.isEditing,
      readErrors: item.readErrors,
      readStatus: item.readStatus,
      validationErrors: item.validationErrors,
      saveErrors: item.saveErrors,
      name: item.name,
      description: item.description,
      selectSource: item.selectSource,
      queryAccess: item.access.query_access,
      allowCohortVisualisations: settings.expose_cohort_visualisations,
      expandedCharts: item.expandedCharts,
      activeQueryUUID: item.activeQueryUUID,
    }
  );
};

export const mapStateToProps = ({
  auth: { role },
  cohorts: { cohorts },
}, { category, code, url }) => {
  const item = findResult(cohorts, category, code)
      || findResult(cohorts, category, code, 'previousCode');
  return item ? withItem(item, role, url) : withoutItem(role, url);
};

export const mapDispatchToProps = {
  updateProperties: updateCohortProperties,
};

export default CohortPanelContainer;
